

// Client-side authentication constants
export const AUTH_CONFIG = {
  // Enable authentication protection - automatically disable on localhost
  // enableAuth: (() => {
  //   // Check if we're in browser environment
  //   if (typeof window !== 'undefined') {
  //     const isLocalhost = window.location.hostname === 'localhost' ||
  //                        window.location.hostname === '127.0.0.1';

  //     // Disable auth on localhost for development
  //     if (isLocalhost) {
  //       console.log('[Auth Config] Localhost detected - disabling authentication for development');
  //       return false;
  //     }
  //   }

  //   // Use config setting for production (default to enabled if not set)
  //   return serviceConfig.NEXT_PUBLIC_ENABLE_AUTH_PROTECTION !== '0';
  // })(),
  enableAuth: process.env.NEXT_PUBLIC_ENABLE_AUTH_PROTECTION !== '0',

  // Auth provider
  provider: process.env.NEXT_PUBLIC_AUTH_PROVIDER || 'account',

  // App configuration
  appUrl: (() => {
   return process.env.NEXT_PUBLIC_APP_URL;
  })(),
  basePath: '',

  // Auth endpoints (routed through AI Transform auth proxy)
  endpoints: {
    // These routes go through the AI Transform auth proxy service
    authorization: '/api/ai-transform/auth/v1/auth/authorization-url',
    me: '/api/ai-transform/auth/v1/auth/me',
    userinfo: '/api/ai-transform/auth/v1/auth/userinfo/session',
    logout: '/api/ai-transform/auth/v1/auth/logout',
    refresh: '/api/ai-transform/auth/v1/auth/refresh',
  },

  // Skip authentication for these paths
  skipPaths: [
    '/login',
    '/signup',
    '/auth',
    '/callback',
    '/error',
    '/403',
    '/unauthorized',
    '/api/health',
    '/_next',
    '/favicon.ico',
  ],
} as const;
